<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域：适配维保记录字段 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="设备名称">
                        <el-input v-model="searchForm.deviceName" placeholder="请输入设备名称" clearable
                            @input="handleInputSearch"> <!-- 新增输入实时过滤 -->
                        </el-input>
                    </el-form-item>
                    <el-form-item label="维保日期">
                        <el-date-picker v-model="searchForm.dateRange" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                            @change="handleDateRangeChange"> <!-- 新增日期变更过滤 -->
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="handleSearch()">查询</el-button>
                        <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域：展示维保记录列表 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="displayRecordList" height="65vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceName" label="设备名称" align="center" show-overflow-tooltip />
                    <el-table-column prop="deviceSerialnumber" label="设备序列号" align="center" show-overflow-tooltip />
                    <el-table-column prop="dateTime" label="维保时间" align="center" />
                    <el-table-column prop="content" label="维保内容" align="center" show-overflow-tooltip />
                    <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip />
                    <el-table-column prop="repairman" label="操作人" align="center" />
                    <el-table-column prop="room" label="功能间" align="center">
                        <!-- <template #default="scope">
                            {{ getRoomName(scope.row.roomId) }}
                        </template> -->
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="220" fixed="right">
                        <template #default="scope">
                            <el-button size="small" type="primary" icon="el-icon-view"
                                @click="showDetail(scope.row)">详情</el-button>
                            <el-button @click="deleteDevice(scope.row)" type="danger" size="small"
                                icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount" :disabled="loading">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- 【改造】设备详情抽屉 -->
        <el-drawer title="维保详情" :visible.sync="detailDrawerVisible" placement="right" size="60%"
            :close-on-click-modal="false" :append-to-body="true" custom-class="detail-drawer" :z-index="2002">

            <!-- 【新增】Tab组件 -->
            <el-tabs v-model="activeTab" type="border-card">

                <!-- Tab 1: 配件列表 -->
                <el-tab-pane label="配件列表" name="accessories">
                    <el-table :data="currentRecord.accessories" border style="width: 100%"
                        v-loading="!currentRecord.accessories">
                        <el-table-column prop="accessoriesName" label="配件名称"></el-table-column>
                        <el-table-column prop="accessoriesNum" label="数量"></el-table-column>
                        <el-table-column prop="accessoriesType" label="配件类型"></el-table-column>
                    </el-table>
                </el-tab-pane>

                <!-- Tab 2: 维保前图片 -->
                <el-tab-pane label="维保前图片" name="before">
                    <div class="image-wrapper">
                        <el-image v-for="(item, index) in currentRecord.frontPhoto" :key="`before-${index}`"
                            :src="item.url" class="thumbnail"
                            :preview-src-list="currentRecord.frontPhoto.map(img => img.url)" fit="cover"></el-image>
                        <span v-if="!currentRecord.frontPhoto || currentRecord.frontPhoto.length === 0"
                            class="no-image-text">暂无图片</span>
                    </div>
                </el-tab-pane>

                <!-- Tab 3: 维保中图片 -->
                <el-tab-pane label="维保中图片" name="during">
                    <div class="image-wrapper">
                        <el-image v-for="(item, index) in currentRecord.middlePhoto" :key="`during-${index}`"
                            :src="item.url" class="thumbnail"
                            :preview-src-list="currentRecord.middlePhoto.map(img => img.url)" fit="cover"></el-image>
                        <span v-if="!currentRecord.middlePhoto || currentRecord.middlePhoto.length === 0"
                            class="no-image-text">暂无图片</span>
                    </div>
                </el-tab-pane>

                <!-- Tab 4: 维保后图片 -->
                <el-tab-pane label="维保后图片" name="after">
                    <div class="image-wrapper">
                        <el-image v-for="(item, index) in currentRecord.afterPhoto" :key="`after-${index}`"
                            :src="item.url" class="thumbnail"
                            :preview-src-list="currentRecord.afterPhoto.map(img => img.url)" fit="cover"></el-image>
                        <span v-if="!currentRecord.afterPhoto || currentRecord.afterPhoto.length === 0"
                            class="no-image-text">暂无图片</span>
                    </div>
                </el-tab-pane>
            </el-tabs>

        </el-drawer>
    </div>
</template>

<script>
import { getRoomList } from "@/api/function";
import { getMaintenanceList, delMaintenance } from "@/api/maintenance";

export default {
    data() {
        return {
            // 搜索表单：对齐维保记录字段
            searchForm: {
                deviceName: '',
                dateRange: ''
            },
            roomList: [],
            allRecordList: [], // 存储全量维保记录（仅初始化加载一次）
            filteredRecordList: [], // 前端过滤后的记录
            displayRecordList: [], // 当前页显示的记录
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            loading: false,
            // 抽屉相关
            detailDrawerVisible: false,
            currentRecord: {
                accessories: [],
                frontPhoto: [],
                middlePhoto: [],
                afterPhoto: []
            }, // 当前选中的维保记录
            // 【新增】Tab的激活状态
            activeTab: 'accessories',
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        async deleteDevice(row) {
            this.$confirm(`确定要删除 ${row.deviceName} 吗?`, '提示', { type: 'warning' })
                .then(async () => {
                    try {
                        // 先调用后端删除接口
                        await delMaintenance({ id: row.id, uuid: row.uuid });
                        this.$message.success('删除成功');
                        // 删除后重新加载全量数据（保证数据最新）
                        await this.loadAllMaintenanceRecords();
                        // 重新执行前端过滤
                        this.filterRecords();
                    } catch (error) {
                        console.error('删除维保失败：', error);
                        this.$message.error('操作异常，请重试');
                    }
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
        },

        // 初始化数据
        async initData() {
            try {
                await this.loadRoomList();
                // 加载全量维保记录（不带任何过滤条件）
                await this.loadAllMaintenanceRecords();
                // 初始化过滤（默认显示全部）
                this.filterRecords();
            } catch (error) {
                this.$message.error('数据初始化失败');
                console.error('初始化失败：', error);
            }
        },

        // 加载功能间列表
        async loadRoomList() {
            try {
                const res = await getRoomList({ userId: localStorage.getItem('userId') });
                this.roomList = res.data || [];
            } catch (error) {
                this.$message.error('加载功能间列表失败');
            }
        },

        // 【核心修改】加载全量维保记录（仅传递userId，不传递过滤条件）
        async loadAllMaintenanceRecords() {
            this.loading = true;
            try {
                const res = await getMaintenanceList({
                    userId: localStorage.getItem('userId'),
                    // 移除设备名称和日期范围参数，只获取全量数据
                });
                console.log('全量维保记录数据：', res.data);
                // 处理后端返回格式
                if (res.data && res.data.records) {
                    this.allRecordList = res.data.records || [];
                } else {
                    this.allRecordList = res.data || [];
                }
            } catch (error) {
                this.$message.error('加载维保记录异常，请重试');
                this.allRecordList = [];
            } finally {
                this.loading = false;
            }
        },

        // 【核心新增】前端过滤逻辑（设备名称 + 日期范围）
        filterRecords() {
            let filtered = [...this.allRecordList];

            // 1. 设备名称过滤（模糊匹配，不区分大小写）
            if (this.searchForm.deviceName.trim()) {
                const keyword = this.searchForm.deviceName.trim().toLowerCase();
                filtered = filtered.filter(record => {
                    return record.deviceName && record.deviceName.toLowerCase().includes(keyword);
                });
            }

            // 2. 日期范围过滤
            if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                const startDate = new Date(this.searchForm.dateRange[0]);
                const endDate = new Date(this.searchForm.dateRange[1]);
                // 处理维保时间格式，提取日期部分进行比较
                filtered = filtered.filter(record => {
                    if (!record.dateTime) return false;
                    // 提取dateTime的日期部分（兼容 "yyyy-MM-dd" 或 "yyyy-MM-dd HH:mm:ss" 格式）
                    const recordDateStr = record.dateTime.split(' ')[0];
                    const recordDate = new Date(recordDateStr);
                    // 确保日期在选择的范围内
                    return recordDate >= startDate && recordDate <= endDate;
                });
            }

            // 更新过滤后的列表和总数
            this.filteredRecordList = filtered;
            this.totalCount = filtered.length;
            // 重新分页
            this.paginateData();
        },

        // 根据功能间id获取名称
        getRoomName(roomId) {
            if (!roomId) return '未知功能间';
            const room = this.roomList.find(item => item.id === roomId || item.id === Number(roomId));
            return room ? room.roomName : '未知功能间';
        },

        // 【修改】查询按钮点击 - 仅执行前端过滤
        handleSearch() {
            this.currentPage = 1; // 重置页码到第一页
            this.filterRecords(); // 执行前端过滤
        },

        // 【新增】输入设备名称时实时过滤
        handleInputSearch() {
            this.currentPage = 1;
            this.filterRecords();
        },

        // 【新增】日期范围变更时过滤
        handleDateRangeChange() {
            this.currentPage = 1;
            this.filterRecords();
        },

        // 分页处理
        paginateData() {
            if (this.filteredRecordList.length === 0) {
                this.displayRecordList = [];
                return;
            }
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.displayRecordList = this.filteredRecordList.slice(startIndex, endIndex);
        },

        // 重置搜索条件
        resetSearch() {
            this.searchForm = {
                deviceName: '',
                dateRange: ''
            };
            this.currentPage = 1;
            this.filterRecords(); // 重置后重新过滤（显示全部）
        },

        // 【修改】分页大小改变 - 不再请求后端，仅前端重新分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.paginateData(); // 仅重新计算分页
        },

        // 【修改】当前页改变 - 不再请求后端，仅前端重新分页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateData(); // 仅重新计算分页
        },

        // 【改造】显示详情抽屉
        showDetail(record) {
            // 确保 record 包含所有需要的数组字段，避免渲染错误
            this.currentRecord = {
                accessories: [],
                frontPhoto: [],
                middlePhoto: [],
                afterPhoto: [],
                ...record
            };
            // 每次打开详情时，默认选中第一个Tab（配件列表）
            this.activeTab = 'accessories';
            this.detailDrawerVisible = true;
        },
    }
};
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 10px;
}

/* 【改造】详情抽屉样式 */
::v-deep .detail-drawer {
    .el-drawer__body {
        padding: 20px;
        overflow-y: auto;
    }

    /* Tab内容区域样式 */
    .el-tabs__content {
        padding: 20px;
    }

    /* 图片容器样式 */
    .image-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        min-height: 100px;
        align-items: center;
        justify-content: flex-start;
    }

    /* 缩略图样式 */
    .thumbnail {
        width: 120px;
        height: 120px;
        object-fit: cover;
        cursor: pointer;
        border: 1px solid #dcdfe6;
        transition: all 0.3s;

        &:hover {
            transform: scale(1.05);
            border-color: #409eff;
        }
    }

    /* 无图片提示文本 */
    .no-image-text {
        color: #909399;
        font-size: 14px;
        width: 100%;
        text-align: center;
    }
}
</style>